"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../../components");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DateSelector = function DateSelector(_ref) {
  var allDates = _ref.allDates,
    pageSize = _ref.pageSize,
    isAvailable = _ref.isAvailable,
    value = _ref.value,
    onChange = _ref.onChange,
    onPageChange = _ref.onPageChange;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var viewableDates = pageSize === 1 ? allDates.filter(isAvailable) : allDates;
  var currentPageDates = (0, _utils.getDatesForPage)(viewableDates, currentPage, pageSize);
  var totalPages = (0, _lodash.ceil)(viewableDates.length / pageSize);
  var handlePageChange = function handlePageChange(newPage, autoSelect) {
    setCurrentPage(newPage);
    var newPageDates = (0, _utils.getDatesForPage)(viewableDates, newPage, pageSize);
    onPageChange({
      page: newPage,
      dates: newPageDates
    });
    if (autoSelect) {
      var newAvailableDates = newPageDates.filter(isAvailable);
      var newDate = autoSelect === 'start' ? (0, _lodash.first)(newAvailableDates) : (0, _lodash.last)(newAvailableDates);
      onChange(newDate);
    }
  };
  var hasPreviousPage = currentPage > 0;
  var handlePrevious = function handlePrevious() {
    return handlePageChange(currentPage - 1, 'end');
  };
  var hasNextPage = currentPage + 1 < totalPages;
  var handleNext = function handleNext() {
    return handlePageChange(currentPage + 1, 'start');
  };

  // It's a rare case, but technically pageSize can change when resizing between desktop and mobile.
  // This hook finds the new page for the current value when that occurs.
  (0, _utils.useDynamicPageSize)({
    value: value,
    pageSize: pageSize,
    viewableDates: viewableDates,
    onPageChange: handlePageChange
  });

  // As a controlled component, our parent may dictate our value from above at any time, in which
  // case we must find and navigate to the corresponding page that contains that value.
  (0, _utils.useSyncPageForValue)({
    value: value,
    pageSize: pageSize,
    viewableDates: viewableDates,
    currentPage: currentPage,
    onUnavailable: function onUnavailable() {
      return onChange((0, _lodash.first)(currentPageDates.filter(isAvailable)));
    },
    onPageChange: handlePageChange
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: "caret-left-heavy-24",
    size: "large",
    onClick: handlePrevious,
    disabled: !hasPreviousPage,
    className: "disabled:text-grey-45"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center flex-grow flex-shrink px-[10px]"
  }, pageSize > 1 ? currentPageDates.map(function (date) {
    return /*#__PURE__*/_react.default.createElement("button", {
      key: date.valueOf(),
      className: (0, _classnames.default)('btn bg-transparent border-0 p-0 flex flex-col items-center disabled:text-grey-45 disabled:cursor-not-allowed'),
      onClick: function onClick() {
        return onChange(date);
      },
      disabled: !isAvailable(date)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mb-[3px] tw-body-sm-regular"
    }, date.format('ddd')[0]), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('w-[32px] h-[32px] text-center pt-[6px] tw-label-regular', {
        'rounded-[50%] text-white bg-green1-55': value === null || value === void 0 ? void 0 : value.isSame(date, 'day')
      })
    }, date.format('D')));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center w-full"
  }, currentPageDates.length > 0 ? (0, _lodash.first)(currentPageDates).format('dddd, MMMM D') : 'N/A')), /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: "caret-right-heavy-24",
    size: "large",
    onClick: handleNext,
    disabled: !hasNextPage,
    className: "disabled:text-grey-45"
  }));
};
DateSelector.propTypes = {
  isAvailable: _propTypes.default.func.isRequired,
  pageSize: _propTypes.default.number.isRequired,
  value: _propTypes.default.object,
  onChange: _propTypes.default.func.isRequired,
  onPageChange: _propTypes.default.func
};
var _default = DateSelector;
exports.default = _default;